<template>
	<!-- <div> -->
	<v-card elevation="0">
		<v-card-title class="text-left card-header fixed-card-title2">
			<v-row no-gutters>
				<v-col cols="6">
					<v-toolbar-title>{{ $t('add') }} {{ $t('consumable') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text class="pa-4 pb-0 overflow-y-auto" style="height: calc(100vh - 122px)">
			<v-row dense>
				<v-col cols="12">
					<v-select
						:items="itemsConsumable"
						item-text="name"
						item-value="id"
						dense
						hide-details
						outlined
						:label="$t('models')"
						v-model="itemModel.consumableModelId"
						:menu-props="{ offsetY: true }" />
				</v-col>
				<v-col cols="12">
					<v-text-field
						dense
						hide-details
						outlined
						:label="$t('lot-number')"
						v-model="itemModel.lotNumber"
						@keypress="(e) => /[0-9]/.test(e.key) || e.preventDefault()" />
				</v-col>
				<v-col cols="12">
					<v-menu v-model="menu1" :close-on-content-click="false" offset-y min-width="auto">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="formattedExpirationDate"
								:label="$t('expiration-date')"
								readonly
								v-bind="attrs"
								single-line
								hide-details
								prepend-inner-icon="mdi-calendar"
								dense
								v-on="on"
								outlined />
						</template>
						<v-date-picker
							v-model="itemModel.expirationDate"
							color="primary"
							type="date"
							scrollable
							@change="menu1 = false" />
					</v-menu>
				</v-col>
				<v-col cols="12">
					<v-text-field
						dense
						hide-details
						outlined
						:label="$t('quantity-total')"
						v-model="itemModel.quantityTotal"
						@keypress="(e) => /[0-9.]/.test(e.key) || e.preventDefault()" />
				</v-col>
				<v-col cols="12">
					<v-text-field
						dense
						hide-details
						outlined
						:label="$t('quantity-available')"
						v-model="itemModel.quantityAvailable"
						@keypress="(e) => /[0-9.]/.test(e.key) || e.preventDefault()" />
				</v-col>
				<v-col cols="12">
					<v-text-field dense hide-details outlined :label="$t('currency')" v-model="itemModel.currency" />
				</v-col>
				<v-col cols="12">
					<v-text-field
						hide-details
						:label="$t('cost-per-unit')"
						type="number"
						v-model="itemModel.costPerUnit"
						outlined
						dense
						@keypress="(e) => /[0-9.]/.test(e.key) || e.preventDefault()" />
				</v-col>
				<v-col cols="12">
					<v-text-field dense hide-details outlined :label="$t('supplier-name')" v-model="itemModel.supplierName" />
				</v-col>
			</v-row>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense>
				<v-col cols="6" order="1">
					<v-btn elevation="0" class="cancel-button-style capitalize-text" @click="closeDrawer">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6" order="2">
					<v-btn block color="primary" :disabled="!isSaveButtonDisabled" @click="addNewConsumable">
						{{ $t('save') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { formatTimestamp } from '../../utils/utilities';

export default {
	name: 'AddInventoryConsumable',
	data () {
		return {
			loading: false,
			itemModel: {
				consumableModelId: 0,
				lotNumber: '',
				expirationDate: '',
				quantityTotal: 0,
				quantityAvailable: 0,
				costPerUnit: 0,
				currency: 'USD',
				supplierName: '',
			},
			inventoryConsumableCategoryOptions: [],
			itemsConsumable: [],
			menu1: false,
			selectedDateForBilling: '',
		};
	},
	methods: {
		...mapActions({
			addConsumable: 'inventoryConsumables/addConsumable',
			getConsumableCatalogs: 'inventoryConsumableCatalogs/getConsumableCatalogs',
		}),
		formatTimestamp,
		async getConsumableItems () {
			const resultGet = await this.getConsumableCatalogs();
			this.itemsConsumable = resultGet;
		},
		closeDrawer () {
			this.itemModel = {
				organizationId: 0,
				name: '',
				manufacturer: '',
				internalProductCode: '',
				unitOfMeasure: '',
				minStockThreshold: 0,
				notes: '',
			};
			this.$store.commit('SET_DETAIL_DRAWER_STATE', false);
			this.$store.commit('SET_DETAILS_DRAWER', false);
		},
		async addNewConsumable () {
			const resultAdd = await this.addConsumable(this.itemModel);
			if (resultAdd) {
				this.closeDrawer();
			}
		},
	},
	computed: {
		...mapState({
			selectedConsumableCatalog: (state) => state.inventoryConsumableCatalogs.selectedConsumableCatalog,
			detailsDrawer: (state) => state.detailsDrawer,
		}),
		selectedConsumableCatalog () {
			return this.$store.state.inventoryConsumableCatalogs.selectedConsumableCatalog;
		},
		formattedExpirationDate () {
			return this.itemModel.expirationDate ? this.formatTimestamp(this.itemModel.expirationDate) : '';
		},
		detailsDrawer () {
			return this.$store.state.detailsDrawer;
		},
		isSaveButtonDisabled () {
			return (
				this.itemModel.consumableModelId > 0 &&
				Number(this.itemModel.lotNumber) > 0 &&
				this.itemModel.expirationDate !== '' &&
				Number(this.itemModel.quantityTotal) > 0 &&
				Number(this.itemModel.quantityAvailable) > 0 &&
				Number(this.itemModel.costPerUnit) > 0 &&
				this.itemModel.currency?.trim() &&
				this.itemModel.supplierName?.trim()
			);
		},
	},
	async mounted () {
		this.getConsumableItems();
		this.itemModel.consumableModelId = this.selectedConsumableCatalog.id;
	},
};
</script>
